<template>
  <v-modal id="open-exceeded-users-limit-modal">
    <span slot="header">
      {{ i18nJS.users_limit_reached }}
    </span>
    <div style="height: 230px">
      <warning-msg :message="i18nJS.users_limit_reached_one_message" style="margin-bottom: 10px" :deletable="false" />
      <warning-msg
        :other-class="'alert-error'"
        :message="errorsToString()"
        style="margin-bottom: 10px"
        :deletable="true"
        v-if="savingErrors && savingErrors.length > 0"
      />
      <div v-if="usersDifference && usersDifference > 1">
        {{ i18nJS.users_limit_reached_more_message_one }} {{ usersDifference }} {{ i18nJS.users_limit_reached_more_message_two }}
      </div>
      <div v-else>
        <user-requirement :buId="buId" :index="0" @selected="selectUser($event)" />
        <br />
        <div>
          <span style="margin-right: 10px"> {{ i18nJS.outtype }} </span>
          <v-select2
            v-model="decodesSelected"
            :options-list="decodesForSelect"
            :multiple="false"
            :data-allow-clear="true"
            :data-minimumInputLength="1"
            :class="'full-width'"
          />
        </div>
        <br />
        <div style="display: flex; align-items: center">
          <span style="margin-right: 10px"> {{ i18nJS.datadimissione }} </span>
          <div style="width: 78px">
            <v-date-picker :locale="locale" v-model="curretDate" :max-date="maxDate" />
          </div>
        </div>
      </div>
    </div>
    <span
      slot="footer"
      @click="save()"
      :class="[{ disabled: curretDate == null || userSelected == null || decodesSelected == null }, 'btn btn-success']"
    >
      {{ i18nJS.command.save }}
    </span>
  </v-modal>
</template>

<script>
import vModal from './../vModal';
import apiConnector from '@/epersonam/apiConnector';
import userRequirement from '../print/models/userRequirement';
import warningMsg from '../warningMsg';
import { Route } from '../../route';
import vSelect2 from '../vSelect2';

export default {
  name: 'exceededUsersLimitCount',
  props: [],
  data() {
    return {
      usersDifference: null,
      buId: window.config.business_unit.id,
      maxDate: null,
      curretDate: null,
      userSelected: null,
      decodesForSelect: [],
      decodesSelected: null,
      savingErrors: [],
    };
  },
  components: {
    vModal,
    userRequirement,
    warningMsg,
    vSelect2,
  },
  mounted() {
    // richiedo le codifiche per la dimissione
    apiConnector()
      .get(`${Route.DECODES_CONFIG}/get_values.json?business_unit_id=${window.config.business_unit.id}&cod=user&key=out_type`)
      .then(({ data }) => {
        this.decodesForSelect = data.map((r) => [r.desc, r.id]);
      });
    eventBus.$on('openExceededUsersLimitModal', (result) => {
      this.usersDifference = result.usersDifference;
      this.maxDate = moment(result.datein, i18nJS.time.formats.date_only).toDate();
      this.curretDate = this.maxDate;
      $('#open-exceeded-users-limit-modal').modal('show');
    });
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    locale() {
      return window.locale;
    },
  },
  methods: {
    save() {
      Loader.show();
      apiConnector()
        .put(`${Route.USER}/${this.userSelected.id}/closing_report`, {
          datein: this.curretDate,
          outtype: this.decodesSelected,
        })
        .then((res) => {
          // Se la dimissione è andata a buon fine invio la form di creazione utente
          $('.save-new-user').submit();
        })
        .catch((res) => {
          this.savingErrors = res.response.data.messages;
          Loader.hide();
        });
    },
    selectUser(data) {
      this.userSelected = data.data_selected;
    },
    errorsToString() {
      return `${i18nJS.errors_on_save} ${this.savingErrors.map((savingError, index) => `\n ${index}) ${savingError}`)}`;
    },
  },
};
</script>

<style lang="scss" scoped></style>
